import { render } from "./CheckBoxComponent.vue?vue&type=template&id=025ff0d4&scoped=true"
import script from "./CheckBoxComponent.vue?vue&type=script&lang=js"
export * from "./CheckBoxComponent.vue?vue&type=script&lang=js"

import "./CheckBoxComponent.vue?vue&type=style&index=0&id=025ff0d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-025ff0d4"]])

export default __exports__